"use client";
import useUncompletedQuests from "../hooks/useUncompletedQuests";
import { QuestsList } from "../QuestsList";
import { NoItems } from "@/app/(components)/Basic/NoItems";

const UncompletedQuestsList = () => {
  const { uncompletedQuests, hasNextPage, fetchNextPage } =
    useUncompletedQuests();

  if (!uncompletedQuests?.length) {
    return <NoItems message="No items to display!" />;
  }

  return (
    <QuestsList
      quests={uncompletedQuests}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      completed={false}
    />
  );
};

export default UncompletedQuestsList;
